
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue14 as ObiWindTrue14Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-14.js';
 
 
 

 
 export const ObiWindTrue14 = createComponent({
   react: React,
   tagName: 'obi-wind-true-14',
   elementClass: ObiWindTrue14Element,
   events: {
     
   }
  });
 
 